import React from 'react';
import { round_to } from '../utils/';
import { default as __, RGB_Linear_Shade } from '../utils/chart';
import { useMediaQuery } from '../utils';

const Pie = ({ chart_height, chart_width, onClick, total, values, shades }) => {
  let isLandscape = useMediaQuery('(orientation: landscape)');
  const size = isLandscape ? 160 : 90;
  const normalized = values.map(v => ({
    ...v,
    percent: round_to((v.value / total) * 100, 0) / 100,
  }));

  let cumulativePercent = 0;

  const draw = (slices, size) => {
    let paths = [];

    slices.forEach((slice, index) => {
      let [startX, startY] = __.calc_percent(cumulativePercent);

      cumulativePercent += slice.percent;

      const [endX, endY] = __.calc_percent(cumulativePercent);

      // if the slice is more than 50%, take the large arc (the long way around)
      const largeArcFlag = slice.percent > 0.5 ? 1 : 0;

      // create an array and join it just for code readability
      const d = [
        `M ${startX * size} ${startY * size}`, // Move
        `A ${size} ${size} 0 ${largeArcFlag} 1 ${endX * size} ${endY * size}`, // Arc (size is same as radius)
        `L 0 0`, // Line
      ].join(' ');

      paths.push(
        <path
          key={slice.id}
          d={d}
          style={{ cursor: 'pointer' }}
          onClick={() =>
            onClick({
              value: slice.value,
              label: slice.label,
              percent: slice.percent,
            })
          }
          fill={shades[index]}
        />,
      );
    });
    return paths;
  };

  return (
    <g
      aria-hidden="true"
      transform={`translate(${chart_width / 2},${chart_height / 2})`}
    >
      {draw(normalized, size)}
    </g>
  );
};
export default Pie;
